import {mixHexColors} from "../../util/color-mix.js";

export default () => {
    return (
        <div style={{
            padding: "1rem 2rem",
            margin: "1rem 3rem",
            width: "500px",
            height: "500px",
            backgroundColor: mixHexColors('#9469c0', '#60ec7c',.5),
        }}>
            test
        </div>
    )
}